module.exports = __webpack_public_path__ + "static/media/logo_ncb.9b953899.svg";